module.exports = __webpack_public_path__ + "img/trex.b26eaf48.gif";